<template>
    <skutopia>
   <!-- SECTION 1: DASHBOARD SUMMARY CARDS WITH MENUS -->
    <v-card class="mb-6">
        <v-card-text>
            <v-row>
                <v-col
                v-for="(data, index) in summaryCards"
                :key="index"
                cols="12"
                sm="6"
                md="4"
                class="pr-6"
                >
                <div
                    class="d-flex"
                >
                    <div class="d-flex flex-column gap-y-1">
                    <p class="text-capitalize mb-0">
                        {{ data.label }}
                    </p>

                    <h6 class="text-h4">
                        {{ data.count }}
                    </h6>

                    <div class="d-flex align-center">
                        <div class="text-no-wrap me-2">
                        {{ data.desc }}
                        </div>
                    </div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-avatar
                    :color="data.color"
                    rounded
                    outlined
                    size="44"
                    >
                    <v-icon
                        size="28"
                        color="white"
                    >
                    {{ data.icon }}
                    </v-icon>
                    </v-avatar>
                <v-divider
                    vertical
                    inset
                    class="ml-6 my-0"
                    v-if="index !== summaryCards.length - 1 ? true : false"
                />
                </div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
    
    <!-- MAIN LIST CARD -->
        <v-card >
            <v-card-title class="d-flex align-center flex-wrap">
                Products List ({{ totalProducts }})
                <v-spacer></v-spacer>
                

                <!-- Toggle between list and card view -->
                <v-btn-toggle v-model="viewMode" dense mandatory>
                <v-btn value="card" small :class="{ 'primary white--text': viewMode === 'card' }">
                    <v-icon small>{{ icons.mdiViewGrid }}</v-icon>
                </v-btn>
                <v-btn value="table" small :class="{ 'primary white--text': viewMode === 'table' }">
                    <v-icon small>{{ icons.mdiViewList }}</v-icon>
                </v-btn>
                </v-btn-toggle>
                <v-menu
                    bottom
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                    </v-btn>
                    </template>

                    <v-list>

                        <v-list-item
                            @click="isProductBulkDialog = !isProductBulkDialog"
                            v-if="$can('add','skutopia')"
                        >
                            <v-list-item-title>
                                <span>Images Upload</span>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item 
                            @click="isProductInfoEdit = true"
                            v-if="$can('add','skutopia')"
                        >

                            <v-list-item-title>
                            <span>Product Info Upload</span>
                            </v-list-item-title>
                        </v-list-item>



                    </v-list>
                </v-menu>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col
                    cols="12"
                    sm="4"
                    >
                    <v-autocomplete
                        v-model="selectedMarkets"
                        :items="getFacetOptions('markets')"
                        item-text="label"
                        label="Markets"
                        outlined
                        chips
                        dense
                        hide-details
                        clearable
                        multiple
                        deletable-chips
                        @change="filterChange"
                    >
                        
                        <template v-slot:item="{ props, item }">
                            {{ item.label }} ({{ item.count }})
                        </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col
                    cols="12"
                    sm="4"
                    >
                    <v-autocomplete
                        v-model="selectedCategories"
                        :items="getFacetOptions('categories')"
                        item-text="label"
                        label="Categories"
                        outlined
                        chips
                        dense
                        hide-details
                        clearable
                        multiple
                        deletable-chips
                        @change="filterChange"
                    >
                        
                        <template v-slot:item="{ props, item }">
                            {{ item.label }} ({{ item.count }})
                        </template>
                    </v-autocomplete>
                    </v-col>
                    <v-col
                    cols="12"
                    sm="4"
                    >
                    <v-autocomplete
                        v-model="selectedBrands"
                        :items="getFacetOptions('brands')"
                        item-text="label"
                        label="Brands"
                        outlined
                        chips
                        dense
                        hide-details
                        clearable
                        multiple
                        deletable-chips
                        @change="filterChange"
                    >
                        
                        <template v-slot:item="{ props, item }">
                            {{ item.label }} ({{ item.count }})
                        </template>
                    </v-autocomplete>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider />
            
        <!-- actions -->
        <v-card-text class="d-flex flex-wrap pb-0 mt-4">
            <div class="d-flex align-center">
                <v-form
                    @submit="submitSearch($event)"
                >
                    <v-text-field
                    v-model="searchQuery"
                    placeholder="Search"
                    outlined
                    hide-details
                    dense
                    clearable
                    class="mb-4"
                    style="inline-size: 400px;"
                    :append-icon="icons.mdiSend"
                    @click:append="submitSearch"
                    @click:append-outer="submitSearch"
                    @click:clear="submitSearch(event=null)"
                    >
                    </v-text-field>
                </v-form>
            </div>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="primary"
                        dense
                        text
                        icon
                        @click="isProductBulkSearchDialog = true"
                        v-bind="attrs"
                        v-on="on"
                    >
                            <v-icon>{{ icons.mdiTextBoxEditOutline }}</v-icon>
                    </v-btn>
                </template>
                <span>Bulk Search</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <div class="d-flex gap-x-4">
                <v-btn 
                    color="success" 
                    class="mr-2 white--text"
                    outlined
                    :loading="downloadLoading"
                    @click="exportCatalog"
                >
                    <v-icon left>{{ icons.mdiMicrosoftExcel }}</v-icon>
                    Export 
                </v-btn>
            </div>
            
            <!-- <v-btn
                color="warning"
                outlined
                dense
                class="mr-4"
                @click="isProductBulkDialog = !isProductBulkDialog"
                    v-if="$can('add','skutopia')"
            >Bulk Image Upload</v-btn>
            <v-btn
                color="success"
                outlined
                dense
                class="mr-4"
                @click="isProductInfoEdit = true"
                    v-if="$can('add','skutopia')"
            >
                Bulk Product Info Upload
            </v-btn>
            <v-btn
                color="primary"
                outlined
                dense
                @click="isProductBulkSearchDialog = true"
            >
                Bulk Product Search
            </v-btn> -->
      </v-card-text>

        <v-card-text class="px-0">
            <!-- TABLE VIEW -->
            <v-data-table
                v-if="viewMode === 'table'"
                v-model="selectedProducts"
                :headers="productHeaders"
                :items="productsData"
                :server-items-length="totalProducts"
                :loading="loadProductData"
                :options.sync="options"
                :footer-props="{
                    'items-per-page-options':[options.itemsPerPage],
                    'disable-items-per-page': true,
                }"
            >

                <!-- product  -->
                <template #item.product="{ item }">

                    <div class="d-flex align-center gap-x-4 cursor-pointer"

                        >
                        <v-avatar
                            v-if="item.images && item.images.length > 0"
                            size="38"
                            rounded
                            class="mr-3"
                            @click="openOverlay(item.images[0])"
                        >
                            <v-img
                                :alt="item.name"
                                :src="item.images[0].thumbnail"
                                contain
                            ></v-img>
                        </v-avatar>
                        <router-link :to="{ name: 'product-id', params: { id: item.barcode } }">
                            <div class="d-flex flex-column">
                                <span class="text-high-emphasis font-weight-medium overflow-x-hidden">{{ item.name }}</span>
                                <a class="text-sm">{{ item.brand.name }}</a>
                            </div>
                        </router-link>
                        </div>


                </template>
                <!-- category -->
                <template #item.category="{ item }">
                    <div class="d-flex flex-row">
                        <v-avatar
                            size="30"
                            icon
                            :color="resolveCategory(item.category).color"
                            class="me-4"
                        >
                            <v-icon
                                size="18"
                                dark
                            >
                            {{resolveCategory(item.category).icon}}
                            </v-icon>
                        </v-avatar>
                        <div class="d-flex flex-column">
                            <span class="text-small " v-if="item.category ">{{ item.category.name }}</span>
                            <small v-if="item.market ">@{{ item.market.name }}</small>
                        </div>
                    </div>
                </template>

                <!-- Project Count -->
                <template #item.projects="{ item }">
                    {{ item.projects.length }}
                </template>

                <!-- Actions -->
                <template #item.actions="{ item }">

                <v-menu
                    bottom
                    left
                >
                    <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon>{{ icons.mdiDotsVertical }}</v-icon>
                    </v-btn>
                    </template>

                    <v-list>

                        <v-list-item
                            :to="{name: 'product-id', params: { id: item.barcode }}"
                            target="_blank"
                        >
                            <v-list-item-title>
                                <v-icon
                                    size="20"
                                    class="me-2"
                                >
                                    {{ icons.mdiPencilBoxOutline }}
                                </v-icon>
                                <span>Edit</span>
                            </v-list-item-title>
                        </v-list-item>
                        <v-list-item 
                            :loading="downloadLoading"
                            @click="download(item)"
                        >

                            <v-list-item-title>
                            <v-icon
                                size="20"
                                class="me-2"
                                
                            >
                                {{ icons.mdiDownload }}
                            </v-icon>
                            <span>Download</span>
                            </v-list-item-title>
                        </v-list-item>


                        <v-list-item
                            @click="deleteProduct(item.barcode)"
                            v-if="$can('delete','skutopia')"
                        >
                            <v-list-item-title>
                                <v-icon
                                    size="20"
                                    class="me-2"
                                >
                                    {{ icons.mdiTrashCanOutline }}
                                </v-icon>
                                <span>Delete</span>
                            </v-list-item-title>
                        </v-list-item>


                    </v-list>
                </v-menu>

                </template>
            </v-data-table>
                <!-- CARD VIEW -->
            <div v-else>
                <v-card flat>
                    <v-card-text>
                        <v-row dense>
                        <v-col
                        v-for="(product, index) in productsData"
                        :key="index"
                        cols="12"
                        sm="6"
                        md="3"
                        lg="2"
                        >
                            <v-card outlined class="pa-3 d-flex flex-column justify-space-between h-100">
                                
                                <!-- Product Image -->
                                <v-img
                                v-if="product.images && product.images.length"
                                :src="product.images[0].thumbnail"
                                contain
                                height="120"
                                class="mb-2"
                                @click="openOverlay(product.images[0])"
                                />
                                <v-avatar v-else size="120" class="mb-2 d-flex align-center mx-auto">
                                <v-icon size="48" color="grey lighten-1">{{icons.mdiCameraOff}}</v-icon>
                                </v-avatar>

                                <!-- Product Name -->
                                <div class="text-center mb-1">
                                <router-link :to="{ name: 'product-id', params: { id: product.barcode } }">
                                    <span class="font-weight-medium text-truncate d-block">{{ product.name }}</span>
                                </router-link>
                                <small class="text-muted">{{ product.barcode }}</small>
                                </div>

                                <!-- Brand + Market -->
                                <div class="text-center text-sm text-muted">
                                {{ product.brand && product.brand.name }} |
                                {{ product.market && product.market.name }}
                                </div>
                                <div class="text-center">
                                    <span class="text-muted">Projects: {{ product.projects.length }}</span>
                                </div>
                            </v-card>
                        </v-col>
                        </v-row>
                    </v-card-text>
                    <infinite-loading
                        ref="infiniteLoading"
                        @infinite="loadProducts"
                    >
                        <div slot="spinner"></div>
                        <div slot="no-more"></div>
                        <div slot="no-results"></div>
                    </infinite-loading>
                </v-card>
            </div>
        </v-card-text>
    </v-card>

    <product-bulk
            :is-product-bulk-dialog.sync="isProductBulkDialog"
    ></product-bulk>

    <product-bulk-search
        :is-dialog-open.sync="isProductBulkSearchDialog"
        @bulkResults="handleBulkResults"
    />

    <product-info-bulk
        :is-product-info-edit.sync="isProductInfoEdit"
    >

    </product-info-bulk>

    <v-dialog v-model="overlayOpen" width="80%">  <!-- Full-size image dialog -->
        <v-card>
            <v-card-title>
            {{ selectedImage ? `${selectedImage.name} - ${selectedImage.side} - ${selectedImage.uploaded_at}` : '' }}
            </v-card-title>

            <v-img
                :src="selectedImage ? selectedImage.image : ''"
                :lazy_src="selectedImage ? selectedImage.thumbnail : ''"
                max-height="80vh"
                max-width="100%"
                contain
            >
            <template v-slot:placeholder>
                <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                    color="grey-lighten-4"
                    indeterminate
                ></v-progress-circular>
                </div>
            </template>
            </v-img>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="closeOverlay">Close</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    </skutopia>
</template>

<script>
import { ref, onUnmounted, onMounted, watch, nextTick,getCurrentInstance } from '@vue/composition-api'
import store from '@/store'

import {
  mdiSend,
  mdiPencilBoxOutline,
  mdiDownload,
  mdiTrashCanOutline,
  mdiLayersTripleOutline,
  mdiFoodOutline,
  mdiBeerOutline,
  mdiBabyBottleOutline,
  mdiBottleTonicPlusOutline,
  mdiHomeHeart,
  mdiToyBrickOutline,
  mdiPaw,
  mdiTshirtCrewOutline,
  mdiDotsVertical,
  mdiViewGrid,
  mdiViewList,
  mdiCameraOff,
  mdiMicrosoftExcel,
  mdiTextBoxEditOutline,
} from '@mdi/js'

import useProduct from '../useProduct'
import Skutopia from '@/views/apps/skutopia/Skutopia.vue'
import ProductBulk from '../bulk/ProductBulk.vue'
import ProductBulkSearch from '../bulk/ProductBulkSearch.vue'
import ProductInfoBulk from '../bulk/ProductInfoBulk.vue'
import InfiniteLoading from 'vue-infinite-loading'
import { skutopiaRequest } from '@/config/authConfig'
import skutopiaStoreModule from '@/views/apps/skutopia/skutopiaStoreModule'


export default ({
    components: {
        Skutopia,
        ProductBulk,
        ProductInfoBulk,
        ProductBulkSearch,
        InfiniteLoading,
    },
    setup() {

        const vm = getCurrentInstance().proxy
        const SKUTOPIA_APP_STORE_MODULE_NAME = 'app-skutopia'

        // Register module
        if (!store.hasModule(SKUTOPIA_APP_STORE_MODULE_NAME)) store.registerModule(SKUTOPIA_APP_STORE_MODULE_NAME, skutopiaStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
        if (store.hasModule(SKUTOPIA_APP_STORE_MODULE_NAME)) store.unregisterModule(SKUTOPIA_APP_STORE_MODULE_NAME)
        })


        const viewMode = ref('table')
        const page = ref(1)
        const isLoadMore = ref(true)
        const infiniteLoading = ref(null)
        const isProductBulkDialog = ref(false)
        const isProductBulkSearchDialog = ref(false)
        const isProductInfoEdit = ref(false)
        const searchQuery = ref('')
        const selectedImage = ref({})
        const overlayOpen = ref(false)
        const productHeaders = ref([
            {
                text: 'PRODUCT',
                value: 'product'
            },
            {
                text: 'UPC/EAN',
                value: 'barcode',
            },
            {
                text: 'CATEGORY',
                value: 'category'
            },
            {
                text: 'PROJECTS',
                value: 'projects',
            },
            {
                text: 'LAST UPLOADED',
                value: 'uploaded_at',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
            },
        ])


        const resolveCategory = category => {
            if (category != undefined){
                if (category.code === 'food') return { color: 'error', icon: mdiFoodOutline }
                if (category.code === 'beverage') return { color: 'info', icon: mdiBeerOutline }
                if (category.code === 'baby') return { color: 'primary', icon: mdiBabyBottleOutline }
                if (category.code === 'health_beauty') return { color: 'success', icon: mdiBottleTonicPlusOutline }
                if (category.code === 'household') return { color: 'warning', icon: mdiHomeHeart }
                if (category.code === 'toy') return { color: 'primary', icon: mdiToyBrickOutline }
                if (category.code === 'pet') return { color: 'primary', icon: mdiPaw }
            }
            return {
                color: 'primary',
                icon: mdiTshirtCrewOutline,
            }
        }

        const resolveStatus = statusMsg => {
        if (statusMsg === 'Scheduled')
            return {
            text: 'Scheduled',
            color: 'warning',
            }
        if (statusMsg === 'Published')
            return {
            text: 'Publish',
            color: 'success',
            }
        if (statusMsg === 'Inactive')
            return {
            text: 'Inactive',
            color: 'error',
            }
        }

        const selectedProducts = ref([])

        const {
            productsData,
            options,
            loadProductData,
            totalProducts,
            

            // Actions
            downloadLoading,
            deleteProduct,
            downloadImages,
            fetchProducts,
        

            // Facets
            marketLoading,
            categoryLoading,
            brandLoading,
            exportCatalog,
            getFacetOptions,
            currentDetailedList,
            summaryCards,
            resetFilters, 
            facets,
            
            // Filter Arrays
            selectedCategories,
            selectedMarkets,
            selectedProjects,
            selectedBrands,


        } = useProduct()

        const resetProducts = () => {
            page.value = 1
            productsData.value = []
            isLoadMore.value = true
            if (infiniteLoading.value) infiniteLoading.value.stateChanger.reset()
        }

        const filterChange = async (item) => {
            console.log(selectedMarkets.value)
            await fetchProducts()
        }


        const submitSearch = event => {
            const params = {}
            if (event) {
                event.preventDefault()
                params['search'] = searchQuery.value
            }
            
            loadProductData.value = true
            fetchProducts(params)

            // resetProducts()
            // nextTick(() => {
            //     if (infiniteLoading.value) infiniteLoading.value.attemptLoad()
            // })
        }

        const openOverlay = (image) => {
            selectedImage.value = image;
            overlayOpen.value = true;
        }

        const closeOverlay = () =>  {
            overlayOpen.value = false;
            selectedImage.value = null;
        }

        const handleBulkResults = (products) => {
            productsData.value = products
            totalProducts.value = products.length
            loadProductData.value = false
        }

        const loadProducts = async ($state) => {
            await fetchProductsInfinite($state);
        };

        const download = (product) => {
            const payload = {
                upcs:[product.barcode]
            }
            downloadImages(payload, `${product.barcode}.zip`)
        }

        const fetchProductsInfinite = async ($state = { loaded: () => {}, complete: () => {} }) => {
            try {
                loadProductData.value = true
                console.log(searchQuery.value)
                await store.dispatch('app-skutopia/fetchProducts', {
                search: searchQuery.value || '',
                fields: ['id', 'name', 'barcode', 'images', 'brand', 'category', 'market', 'created_at'],
                page: page.value,
                itemsPerPage: options.value.itemsPerPage || 25
                }).then(response => {

                const { results, total_pages, count } = response.data
                const existingIds = new Set(productsData.value.map(p => p.id))
                const newProducts = results.filter(p => !existingIds.has(p.id))
                productsData.value.push(...newProducts)

                if (page.value < total_pages){
                    $state.loaded()
                    page.value += 1

                } else {
                    isLoadMore.value = false
                    $state.complete()
                }
                })
            } catch (err) {
                console.error(err)
                $state.complete()
            } finally {
                loadProductData.value = false
            }
        }

        watch([options], () => {
            const params = {
                search: searchQuery.value
            }
            fetchProducts(params)
        })

        onMounted(() => {
            nextTick(() => { if (infiniteLoading.value) { infiniteLoading.value.stateChanger.reset() }})
            
        })


        return {
            isProductBulkDialog,
            isProductBulkSearchDialog,
            isProductInfoEdit,
            handleBulkResults,
            searchQuery,
            productsData,
            options,
            loadProductData,
            totalProducts,
            productHeaders,
            selectedProducts,
            downloadLoading,
            download,
            resolveCategory,
            resolveStatus,
            submitSearch,
            deleteProduct,
            getFacetOptions,

            openOverlay,
            selectedImage,
            overlayOpen,
            closeOverlay,

            viewMode,
            loadProducts,
            isLoadMore,
            searchQuery,
            page,
            infiniteLoading,

            summaryCards,
            currentDetailedList,
            filterChange,
            exportCatalog,
            resetFilters, 
            facets,
            
            marketLoading,
            categoryLoading,
            brandLoading,

            selectedCategories,
            selectedMarkets,
            selectedProjects,
            selectedBrands,


            icons: {
                mdiSend,
                mdiPencilBoxOutline,
                mdiDownload,
                mdiTrashCanOutline,
                mdiLayersTripleOutline,
                mdiDotsVertical,
                mdiViewGrid,
                mdiViewList,
                mdiCameraOff,
                mdiMicrosoftExcel,
                mdiTextBoxEditOutline
            }
        }

    },
})
</script>

<style scoped>
.text-high-emphasis {
    color: rgba(46, 38, 61, 0.9) !important;
}
</style>
